import { merge } from '../../helper';

import deepMerge from '../../general/deepMerge';

import * as exElement from '../../utils/element';
import type { IElementConfig } from '../../utils/element/types';

import * as exProgress from '../progress';
import type { IProgressConfig } from './create';

// ----------------------------------------------------------------------------

export interface IProgressStackedConfig extends IElementConfig {
    progress?: IProgressConfig;
    data?: IProgressConfig[];
}

// ----------------------------------------------------------------------------

function create(config: IProgressStackedConfig = {}): HTMLElement {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elProgressStacked = exElement.create({
        merge: defConfig,
        class: {
            new: 'progress-stacked',
        },
    });

    // ------------------------------------------------------------------------

    //
    for (const item of defConfig.data) {
        const defConfigItem: Record<string, any> = {};
        deepMerge(defConfigItem, item, defConfig.progress);

        // --------------------------------------------------------------------

        //
        const progress = exProgress.create({
            merge: defConfigItem,
        });
        elProgressStacked.appendChild(progress.element);
    }

    // ------------------------------------------------------------------------

    //
    return elProgressStacked;
}

// ----------------------------------------------------------------------------

export { create };
